import { LogglyTracker } from 'loggly-jslogger';
const logger = new LogglyTracker();
logger.push({
    'logglyKey': '0b9dc68e-5386-44aa-a808-b1eb6277c39a',
    'sendConsoleErrors': true,
    'tag': 'loggly-jslogger1'
});
export default logger;